import { createFileRoute } from '@tanstack/react-router'
import { SupportPage } from '@/features/support'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/support/')({
  component: SupportPage,
  beforeLoad: requireRole(['admin', 'reseller', 'customer']),
})

